import React, { useState } from 'react';
import { supabase } from '../services/supabaseClient';
import { ORG_NAME } from '../constants';
import { Shield, AlertCircle } from 'lucide-react';

const Login: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      // This triggers the OAuth flow.
      // Configure 'azure' provider in Supabase Dashboard.
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'azure',
        options: {
          scopes: 'email',
          redirectTo: window.location.origin
        }
      });
      if (error) throw error;
    } catch (e: any) {
      setError(e.message || "Failed to initiate login");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 p-8 text-center">
        <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-blue-900/20">
          <Shield className="h-8 w-8 text-white" />
        </div>
        
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">{ORG_NAME} OS</h1>
        <p className="text-slate-500 dark:text-slate-400 mb-8">Editorial Workflow & AI Automation Platform</p>
        
        {error && (
          <div className="mb-6 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg flex items-center text-left">
            <AlertCircle className="h-5 w-5 text-red-600 dark:text-red-400 mr-3 flex-shrink-0" />
            <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={loading}
          className="w-full flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors shadow-sm disabled:opacity-70 disabled:cursor-not-allowed"
        >
          {loading ? (
            <span className="animate-pulse">Connecting...</span>
          ) : (
            <>
              <svg className="h-5 w-5 mr-3" viewBox="0 0 23 23" fill="currentColor">
                <path fill="#f35325" d="M1 1h10v10H1z"/>
                <path fill="#81bc06" d="M12 1h10v10H12z"/>
                <path fill="#05a6f0" d="M1 12h10v10H1z"/>
                <path fill="#ffba08" d="M12 12h10v10H12z"/>
              </svg>
              Sign in with Microsoft
            </>
          )}
        </button>
        
        <p className="mt-6 text-xs text-slate-400 dark:text-slate-500">
          Authorized personnel only. All activity is logged.
        </p>
      </div>
    </div>
  );
};

export default Login;